import { fromJS } from 'immutable';

export const emptyObject = {};
export const emptyArray = [];
export const emptyList = fromJS(emptyArray);
export const emptyMap = fromJS(emptyObject);
